export const openIAKey = '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'
export const KEY_ASSISTANT_PESV = 'asst_pAtzc0VGS6Ug6ztPt3YSkiSx'
export const KEY_ASSISTANT_SGSST = 'asst_kVQFbzQ522vMjZgMSp1pheqB'
export const KEY_ASSISTANT_LABORAL = 'asst_SnCjXCAZXBTw0QS8scX61NDx'